import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import { ITicketsBalances, ITicketsError, IUserInfo } from "../../model/user-info.interface";
import { loginHandler } from "./login.handler";
import { ReactNode } from "react";
import applyBonusesHandler from "./apply-bonuses.handler";
import { now } from "../../utils/time";
import makeProfitHandler from "./make-profit.handler";
import setUserBalanceAndLogHandler from "./set-user-balance-and-log.handler";
import { checkJoinChannelsTasks, ICheckJoinChannelResponse } from "../tasks/check-join-channel.handler";
import { finishQuiz, IFinishQuizResponse } from "../quizzes/finish-quiz.handler";
import { convertEnergy, convertEnergyFulfilledHandler } from "../work/convert-enegry.handler";

export interface IUserInfoState extends IUserInfo, IRequestState {};

const initialState: IUserInfoState = {
    id: 0,
    recordId: 0,
    exp: 0,
    level: 0,

    balance: 0,
    tickets: {
        regularTickets: 0,
        rareTickets: 0,
        epicTickets: 0,
        legendaryTickets: 0,
    },
    balanceError: '',
    ticketsBalanceError: null,

    profit: 0,
    realTimeProfitState: true,
    makedProfit: 0,
    lastProfitMaking: 0,

    yclid: null,

    isFirstLaunch: undefined,
    bonuses: [],

    allowWrite: undefined,

    loading: false,
    error: "",
};

const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {
        setUserBalance: (state, action: PayloadAction<{ balance: number, visual?: boolean }>) => {
            state.balance = action.payload.balance;

            if (!action.payload.visual)
                state.lastProfitMaking = now();
        },
        setUserTickets: (state, action: PayloadAction<ITicketsBalances>) => {
            state.tickets = action.payload;
        },
        setBalanceError: (state, action: PayloadAction<ReactNode>) => {
            state.balanceError = action.payload;
        },
        setTicketsBalanceError: (state, action: PayloadAction<ITicketsError | null>) => {
            state.ticketsBalanceError = action.payload;
        },
        setUserExp: (state, action: PayloadAction<number>) => {
            state.exp = action.payload;
        },
        setProfit: (state, action: PayloadAction<number>) => {
            state.profit = action.payload;
        },
        resetMakedProfit: (state) => {
            state.makedProfit = 0;
        },        
    },
    extraReducers: (builder: ActionReducerMapBuilder<IUserInfoState>) => {
        loginHandler(builder);
        applyBonusesHandler(builder);
        makeProfitHandler(builder);
        setUserBalanceAndLogHandler(builder);

        builder.addCase(checkJoinChannelsTasks.fulfilled, (state: IUserInfoState, action: PayloadAction<ICheckJoinChannelResponse>) => {
            if (action.payload.exp)
                state.exp = action.payload.exp;

            if (action.payload.tickets)
                state.tickets = action.payload.tickets;
        });

        builder.addCase(finishQuiz.fulfilled, (state: IUserInfoState, action: PayloadAction<IFinishQuizResponse>) => {
            if (action.payload.exp)
                state.exp = action.payload.exp;

            if (action.payload.tickets)
                state.tickets = action.payload.tickets;
        });

        builder.addCase(convertEnergy.fulfilled, convertEnergyFulfilledHandler);
    },
});

export default userInfoSlice.reducer;
export const {
    setUserBalance, setUserTickets, setUserExp,
    setBalanceError, setProfit, resetMakedProfit,
    setTicketsBalanceError } = userInfoSlice.actions;